import * as angular from "angular";
import {BreadcrumbsController} from "./breadcrumbs.controller";
const templateUrl = require("./breadcrumbs.html");

export const breadcrumbs: angular.IDirective = {
    templateUrl: templateUrl,
    controller: BreadcrumbsController,
    controllerAs: "vm",
    bindToController: true,
    scope: {
        crumbs: "="
    }
};


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/breadcrumbs/breadcrumbs.ts
 **/